import FBPostCRUDActions from '@mm/state/actions/FBPostCRUDActions';
import downArrow from 'assets/icons/arrow-down.svg';
import classnames from 'classnames';
import he from 'he';
import moment from 'moment';
import React from 'react';
import ReactEmoji from 'react-emoji';
import { connect } from 'react-redux';
import { Media } from 'reactstrap';
import { compose, lifecycle, withHandlers, withStateHandlers } from 'recompose';
import Input from '../../../../../../common/components/Input/Input';
import customersLogo from 'assets/logo-customers-blue.svg';
import { mapDropdownStateToProps } from '../../mappers/stateToPropsMapper';
import './CGDropdown.scss';
import DropdownItem from './DropdownItem';

const pictureSrc = picture => picture || customersLogo;

const filteredPosts = (posts, searchText) =>
  posts.filter(
    post =>
      !searchText ||
      post.message.toLowerCase().indexOf(searchText.toLowerCase()) >= 0,
  );

const getSelectedPostId = selectedPost => {
  const fullPostId = selectedPost.promotableId || selectedPost.id;

  if (fullPostId) {
    return fullPostId.split('_')[1];
  }

  return '';
};

const CGDropdown = ({
  posts,
  toggledOn,
  toggle,
  post,
  setPost,
  updateGuard,
  disabled,
  searchText,
  setSearchText,
}) => {
  const classList = classnames('cg-dropdown__dropdown', {
    'cg-dropdown--disabled': disabled,
  });

  return (
    <div className={classList}>
      <div className="cg-dropdown__button">
        <Media
          onClick={() => toggle(!toggledOn)}
          className="cg-dropdown__dropbtn cg-dropdown__item cg-dropdown__item-main"
        >
          <Media left className="cg-dropdown__dropbtn">
            <Media
              object
              src={pictureSrc(post.picture)}
              alt="post image"
              className={classnames(
                'cg-dropdown__dropbtn cg-dropdown__item-image',
                { 'cg-dropdown__default-image': !post.picture },
              )}
            />
          </Media>
          <Media body className="cg-dropdown__dropbtn">
            <Media heading className="cg-dropdown__dropbtn">
              {moment(post.createdAt).format('MMMM Do, YYYY h:mm a')}
            </Media>
            {ReactEmoji.emojify(he.decode(post.message || ''))}
          </Media>
        </Media>
        <div className="cg-dropdown__caret" onClick={() => toggle(!toggledOn)}>
          <img className="cg-dropdown__arrow" src={downArrow} alt="" />
        </div>
      </div>
      {!disabled && (
        <div
          className={classnames('cg-dropdown__dropdown-content', {
            'cg-dropdown__show': toggledOn,
          })}
        >
          <Input
            className="cg-dropdown__search"
            placeholder="Filter by name"
            onChange={e => setSearchText(e.target.value)}
            value={searchText}
          />
          {filteredPosts(posts, searchText).map(p => (
            <DropdownItem
              onSelect={() => {
                setPost(p);
                updateGuard(p);
              }}
              key={p.id}
              item={p}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  getFBPosts: pageId => dispatch(FBPostCRUDActions.retrieveAll(pageId, true)),
});

const hideDropdown = props => event => {
  if (
    !event.target.matches('.cg-dropdown__dropbtn') &&
    !event.target.matches('.cg-dropdown__caret') &&
    !event.target.matches('.cg-dropdown__arrow') &&
    !event.target.matches('.cg-dropdown__search')
  ) {
    props.toggle(false);
  }
};

const setPost = () => value => ({ post: value });
const toggle = () => value => ({ toggledOn: value });
const setSearchText = () => value => ({ searchText: value });

const setRequestingPost = () => value => ({ requestingPost: value });

function componentDidMount() {
  window.onclick = hideDropdown(this.props);
  this.props.setPost(this.props.selectedPost);

  const {
    guard: { postId: currentPostId },
  } = this.props;
  const selectedPostId = getSelectedPostId(this.props.selectedPost);

  if (selectedPostId !== currentPostId) {
    const { updateGuard, selectedPost } = this.props;
    updateGuard(selectedPost);
  }
}

function componentWillReceiveProps(nextProps) {
  const { selectedPost } = this.props;
  const {
    requestingPost,
    setRequestingPost,
    connectedPage,
    getFBPosts,
    selectedPost: nextPost,
  } = nextProps;

  if (selectedPost && nextPost && selectedPost.id !== nextPost.id) {
    nextProps.setPost(nextProps.selectedPost);
  }

  if (!requestingPost && connectedPage && connectedPage.id) {
    getFBPosts(connectedPage.id);
    setRequestingPost(true);
  }
}

const initialState = {
  post: {},
  toggledOn: false,
  requestingPost: false,
  searchText: '',
};

const enhance = compose(
  connect(mapDropdownStateToProps, mapDispatchToProps),
  withStateHandlers(initialState, {
    setPost,
    toggle,
    setRequestingPost,
    setSearchText,
  }),
  withHandlers(hideDropdown),
  lifecycle({ componentDidMount, componentWillReceiveProps }),
);

export default enhance(CGDropdown);
